import React, { useEffect, useState, useContext } from "react";
import {FormControlLabel, Popover, Checkbox
  } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import FilterAltTwoToneIcon from '@mui/icons-material/FilterAltTwoTone';
import {
    setState,
} from "./defineSlice";

const CustomerTypePopover = () => {
    const [anchorType, setAnchorType] = useState(null);
    const dispatch = useDispatch();
    const define = useSelector((state) => state.define);
    const { gridData, filter_customerTypes, filter_customerTrustLevels, customerTypes, selectedProduct } = define;
    const [customerType, setcustomerType] = React.useState([]);

    const handleCheckboxTypeChange = (category) => {
        // setcustomerType((prev) =>
        //   prev.includes(category) ? prev.filter((c) => c !== category) : [...prev, category]
        // );
        let val = filter_customerTypes.includes(category) ? filter_customerTypes.filter((c) => c !== category) : [...filter_customerTypes, category];
        dispatch(setState("filter_customerTypes", val));
    };
    const handleHeaderTypeClick = (event) => {
        setAnchorType(anchorType ? null : event.currentTarget);
    };
    // useEffect(()=>{
    //     dispatch(setState("filter_customerTypes", customerType));
    // },[customerType]);

    const handleCloseType = () => {
        setAnchorType(null);
    };

    useEffect(()=>{
        //let filteredData = filterGridDataByCustomerTypes();
        //filteredData = filterGridDataByTrustLevels(filteredData);
        let val = gridData?.filter((item) =>{
          return(
          (filter_customerTypes.length === 0 || filter_customerTypes.some(type => item.type.toLowerCase().includes(type.toLowerCase()))) &&
          (filter_customerTrustLevels.length === 0 || filter_customerTrustLevels.some(level => item.customerTrustLevel.toLowerCase().includes(level.toLowerCase()))) &&
          (selectedProduct.packGroupOrSKUID === 0 || selectedProduct.packGroupOrSKUID === undefined || item.skuid === selectedProduct.packGroupOrSKUID || item.productGroupID === selectedProduct.packGroupOrSKUID)
          );});
        dispatch(setState("gridDataFiltered", val));
    },[filter_customerTypes]);
    
    return(
        <div>
        <div onClick={handleHeaderTypeClick} 
        style={{ display: 'flex', justifyContent: 'space-between', wordWrap: 'break-word', whiteSpace: 'pre-wrap', fontSize: '14px', cursor: 'pointer', lineHeight: '1.2' }}> 
        <span style = {{fontWeight:"700"}}>Customer Type  </span> 
        {filter_customerTypes?.length === 0 &&<FilterAltOutlinedIcon style={{ color: '#bcbcba', fontSize : '20px'}} />}
        {filter_customerTypes?.length > 0 && <FilterAltTwoToneIcon style={{ color: '#6f6f6c', fontSize : '20px'}} />}
        </div>
        <Popover
        open={Boolean(anchorType)}
        anchorEl={anchorType}
        onClose={handleCloseType}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <div style={{ padding: 16, maxHeight: '200px', overflowY: 'auto'}}>
          {customerTypes.map((category) => (
            <FormControlLabel
              control={
                <Checkbox
                  checked={filter_customerTypes.includes(category)}
                  onChange={() => handleCheckboxTypeChange(category)}
                />
              }
              label={category}
              key={category}
              style={{ display: 'block' }}
            />
          ))}
        </div>
      </Popover>
      </div>
    );
}
export default CustomerTypePopover;